import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  Title,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, Title);

const COLORS = {
  approved: "#4CAF50",
  pending: "#FFC107",
  denied: "#F44336",
};

const IncentiveUserRevenueChart = ({ data }) => {

  const labels = data.map((item) => item.userName);

  const chartData = {
    labels,
    datasets: [
      {
        label: "Approved Incentive",
        data: data.map((item) => item.approveRevenue),
        backgroundColor: COLORS.approved,
        stack: "stack1",
        barThickness: 40,       // 👈 control bar width
        maxBarThickness: 50
      },
      {
        label: "Pending Incentive",
        data: data.map((item) => item.pendingRevenue),
        backgroundColor: COLORS.pending,
        stack: "stack1",
        barThickness: 40,       // 👈 control bar width
        maxBarThickness: 50
      },
      {
        label: "Denied Incentive",
        data: data.map((item) => item.deniedRevenue),
        backgroundColor: COLORS.denied,
        stack: "stack1",
        barThickness: 40,       // 👈 control bar width
        maxBarThickness: 50
      },
    ],
  };

  const options = {
    responsive: true,
    interaction: {
      mode: "index",   // 👈 show all dataset values together
      intersect: false // 👈 hover anywhere on bar group
    },
    plugins: {
      legend: {
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          title: function (context) {
            return context[0].label; // Username
          },
      
          beforeBody: function (context) {
            const index = context[0].dataIndex;
            const item = data[index];
      
            return `Total Revenue: ₹${item.totalRevenue}`;
          },
      
          label: function (context) {
            return `${context.dataset.label}: ₹${context.raw}`;
          }
        },
      },
      title: {
        display: true,
        text: "Sales Person Incentive Summary",
      },
    },
    scales: {
      x: {
        stacked: true,
        categoryPercentage: 0.5,
        barPercentage: 0.6,
        title: {
          display: true,
          text: "Sales Person",
        },
      },
      y: {
        stacked: true,
        title: {
          display: true,
          text: "Incentive (₹)",
        },
      },
    },
  };

  return (
    <div className="card p-4">
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default IncentiveUserRevenueChart;